"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SpecController = function SpecController($state, ProductsDataProvider) {
  "ngInject";

  (0, _classCallCheck3.default)(this, SpecController);
  this.product = ProductsDataProvider.products.findOne({ slug: $state.params.product });
};

// WEBPACK FOOTER //


exports.default = SpecController;


/** WEBPACK FOOTER **
 ** ./client/app/modules/products/components/materials/controller.js
 **/